// extracted by mini-css-extract-plugin
var _1 = "SectionChangesConfirmationModal-module__animateUploadProgressBarWidth--qpRWF";
var _2 = "SectionChangesConfirmationModal-module__animatedBackground--jlUrY";
var _3 = "SectionChangesConfirmationModal-module__sectionName--Jk0bt";
var _4 = "SectionChangesConfirmationModal-module__sectionRow--Mt4Mr";
var _5 = "SectionChangesConfirmationModal-module__sectionRowContainer--Rke_U";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "sectionName", _4 as "sectionRow", _5 as "sectionRowContainer" }
